import { IResourceByType } from '@/dto/operationalPlanSummary';

export class StackData {
    public label: string = '';
    public storekeeperFirst?: number;
    public storekeeperSecond?: number;
    public leadStorekeeperInFirst?: number;
    public leadStorekeeperInSecond?: number;
    public leadStorekeeperOutFirst?: number;
    public leadStorekeeperOutSecond?: number;
    public masterFirst?: number;
    public masterSecond?: number;
    public slingerFirst?: number;
    public slingerSecond?: number;

    constructor(label: string, typeRecords: IResourceByType[]) {
        this.label = label;
        for (const typeRecord of typeRecords) {
            for (const shiftRecord of typeRecord.resourcesByShift) {
                const type = typeRecord.type + shiftRecord.shift;
                switch (type) {
                    case 'storekeeper1': {
                        this.storekeeperFirst = shiftRecord.count;
                        break;
                    }
                    case 'storekeeper2': {
                        this.storekeeperSecond = shiftRecord.count;
                        break;
                    }
                    case 'leadstorekeeperin1': {
                        this.leadStorekeeperInFirst = shiftRecord.count;
                        break;
                    }
                    case 'leadstorekeeperin2': {
                        this.leadStorekeeperInSecond = shiftRecord.count;
                        break;
                    }
                    case 'leadstorekeeperout1': {
                        this.leadStorekeeperOutFirst = shiftRecord.count;
                        break;
                    }
                    case 'leadstorekeeperout2': {
                        this.leadStorekeeperOutSecond = shiftRecord.count;
                        break;
                    }
                    case 'master1': {
                        this.masterFirst = shiftRecord.count;
                        break;
                    }
                    case 'master2': {
                        this.masterSecond = shiftRecord.count;
                        break;
                    }
                    case 'slinger1': {
                        this.slingerFirst = shiftRecord.count;
                        break;
                    }
                    case 'slinger2': {
                        this.slingerSecond = shiftRecord.count;
                        break;
                    }
                }
            }
        }
    }
}
